import { PageTitle } from 'components';
import { memo } from 'react';

interface Props {
  title?: string;
}

const PageTitleView: React.FC<Props> = ({ title }) => {
  return <PageTitle>{title}</PageTitle>;
};

export default memo(PageTitleView);
